export const FORWARD_TARGET_LIMIT = 2000;

export function normalizeForwardTargets(chats = []) {
	const targets = [];
	const seen = new Set();
	(Array.isArray(chats) ? chats : []).forEach((chat) => {
		const type = chat && chat.type ? String(chat.type).trim().toUpperCase() : '';
		const targetId = chat && chat.targetId;
		if (!type || (type !== 'PRIVATE' && type !== 'GROUP') || !targetId) {
			return;
		}
		const key = `${type}:${targetId}`;
		if (seen.has(key)) {
			return;
		}
		seen.add(key);
		targets.push({
			type,
			targetId
		});
	});
	return targets;
}

export function prepareForwardTargets(chats = [], limit = FORWARD_TARGET_LIMIT) {
	const sourceChats = Array.isArray(chats) ? chats : [];
	const allTargets = normalizeForwardTargets(sourceChats);
	const targetKeySet = new Set(allTargets.slice(0, limit).map((target) => `${target.type}:${target.targetId}`));
	const selectedChats = [];
	const selectedChatKeys = new Set();
	sourceChats.forEach((chat) => {
		const type = chat && chat.type ? String(chat.type).trim().toUpperCase() : '';
		const targetId = chat && chat.targetId;
		const key = `${type}:${targetId}`;
		if (!targetKeySet.has(key) || selectedChatKeys.has(key)) {
			return;
		}
		selectedChatKeys.add(key);
		selectedChats.push(chat);
	});
	return {
		targets: allTargets.slice(0, limit),
		chats: selectedChats,
		originalCount: allTargets.length,
		truncated: allTargets.length > limit,
		limit
	};
}

export function normalizeForwardMessages(messages = []) {
	return (Array.isArray(messages) ? messages : [])
		.filter(message => message && message.type !== undefined && message.content)
		.map(message => ({
			type: message.type,
			content: message.content
		}));
}

export function extractForwardErrorMessage(error) {
	if (!error) {
		return '';
	}
	if (typeof error.message === 'string' && error.message) {
		return error.message;
	}
	if (typeof error.msg === 'string' && error.msg) {
		return error.msg;
	}
	if (error.response && error.response.data) {
		const data = error.response.data;
		if (typeof data === 'string') {
			return data;
		}
		if (typeof data.message === 'string' && data.message) {
			return data.message;
		}
	}
	return '';
}
